/* eslint-disable no-underscore-dangle */

import z from 'zod';
import { Buffer } from 'buffer';
import { createLogger } from 'services/debugLogger';
import { ConnectedLayerConfig } from '../../types/app.types';
import defaultConfig from './ARENA.config.json';

const logger = createLogger('ARENA');

const ConnectedLayerConfigSchema = z.object({
  interestPoints: z.array(
    z.object({
      lon: z.number(),
      lat: z.number(),
    }),
  ),
  iopointData: z.object(
    {
      variable: z.string(),
      group: z.string(),
      station: z.string(),
    },
  ),
  fetchInterval: z.number(),
  maximunRangeToAskForCompleteAlarmsInSeconds: z.number(),
  areasCoordinates: z.array(
    z.object({
      name: z.string(),
      order: z.number(),
      // Each element of the array represents angle's coordinate in the next order:
      // [right top corner, right bottom corner, left bottom corner,
      // left top corner, right top corner]
      coordinates: z.array(
        z.tuple([z.number(), z.number()]),
      ),
    }),
  ),
});

const parseConnectedLayerConfig = () => {
  const envar = (window as any)._env_.REACT_APP_ARENA_CONFIG;
  if (envar) {
    try {
      const jsonString = Buffer.from(envar, 'base64').toString('utf8');
      const parsedJson = JSON.parse(jsonString);

      // Validar el JSON contra el esquema de zod
      const validatedData = ConnectedLayerConfigSchema.parse(parsedJson);

      return validatedData;
    } catch (error) {
      logger.error('Error parsing ARENA config env var', error);
    }
  }

  return defaultConfig;
};

const ARENALayerConfig: ConnectedLayerConfig = parseConnectedLayerConfig();

export default ARENALayerConfig;
